import { render } from "./Template2.vue?vue&type=template&id=038a16fb&scoped=true"
import script from "./Template2.vue?vue&type=script&lang=ts"
export * from "./Template2.vue?vue&type=script&lang=ts"

import "./Template2.vue?vue&type=style&index=0&id=038a16fb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-038a16fb"

export default script